import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { FeatureUnlockProvider } from './context/FeatureUnlockContext';
import { JobProgressProvider } from './context/JobProgressContext';
import { ThemeProvider } from './context/ThemeContext';

// Extract subdomain from hostname
const extractSubdomain = () => {
  const isProduction = process.env.NODE_ENV === "production";
  
  if (!isProduction) {
    // In development, use 'samplefour' as the subdomain
    return 'samplefour';
  }

  const hostname = window.location.hostname;
  // Examples: hdfc.finansee.eu -> hdfc, sbi.finansee.eu -> sbi
  const parts = hostname.split('.');
  
  // If hostname has at least 3 parts (subdomain.domain.tld), extract the first part
  if (parts.length >= 3) {
    return parts[0];
  }
  
  // Fallback to the full hostname if structure is unexpected
  return hostname;
};

const subdomain = extractSubdomain();

// Clear the old color mode setting before rendering
if (localStorage.getItem('chakra-ui-color-mode')) {
  localStorage.removeItem('chakra-ui-color-mode');
}

// Wrapper component to access theme from context
const AppWithTheme = () => {
  return (
    <ThemeProvider subdomain={subdomain}>
      <ThemeConsumer />
    </ThemeProvider>
  );
};

const ThemeConsumer = () => {
  const { chakraTheme } = React.useContext(require('./context/ThemeContext').default);

  return (
    <ChakraProvider theme={chakraTheme}>
      <ColorModeScript initialColorMode={chakraTheme.config.initialColorMode} />
      <AuthProvider>
        <FeatureUnlockProvider>
          <JobProgressProvider>
            <App />
          </JobProgressProvider>
        </FeatureUnlockProvider>
      </AuthProvider>
    </ChakraProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppWithTheme />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
